<template>
  <div class="code-nvidia-app">
    <div class="header-body-bar py-15">
      <div class="header-body-text px-gen">NWORKFORCE</div>
    </div>
    <div class="side-bar py-gen">
      <div class="px-gen">
        <bundle-list
          @bundle_change="bundle_change"
          @set_stores="set_stores"
          @set_bundles="set_bundles"
          ref="bundle_list"
        />
        <bundle-request ref="bundle_request" />
      </div>
      <system-monitor ref="system_monitor" />
    </div>
    <bundle-detail ref="bundle_detail" />
    <code-request
      ref="code_request"
      @code_requested="code_requested"
      @bdls="bdls"
    />
  </div>
</template>

<script>
import CodeRequest from "./NworkfoceStoreCodeRequest.vue";
import BundleDetail from "./BundleDetail.vue";
import SystemMonitor from "./SystemMonitor.vue";
import BundleRequest from "./BundleRequest.vue";
import BundleList from "./BundleList.vue";

export default {
  name: "NvidiaTicketStore",
  components: {
    CodeRequest,
    BundleDetail,
    SystemMonitor,
    BundleRequest,
    BundleList,
  },
  data() {
    return {
      stores: [], //stores in which the current user is assigned to
      bundles: [],
    };
  },
  methods: {
    bundle_change(bundle) {
      this.$refs.bundle_detail.setBundle(bundle);
    },
    set_stores(stores) {
      this.stores = stores;
      this.$refs.system_monitor.setStores(stores);
      this.$refs.bundle_request.setStores(stores);
    },
    set_bundles(bundles) {
      this.bundles = bundles;
      this.$refs.code_request.setBundles(bundles);
    },
    code_requested() {
      this.$refs.bundle_detail.refresh();
      this.$refs.bundle_list.refresh();
    },
    bdls(bdls) {
      console.log(bdls);
    },
  },
  mounted() {
    // let vm = this;
    // vm.$refs.code_request.setProductTypes([{ name: "cero", value: "cero" }]);
    // vm.setGPUs([{ name: "uno", value: "uno" }]);
    // vm.setBrands([{ name: "dos", value: "dos" }]);
  },
};
</script>

<style scoped>
/* @import url("https://nworkforce.com/librerias/css/fonts/fonts.css"); */

.code-nvidia-app {
  background-color: #f6f2e9 !important;
  height: 100%;
  display: flex;
  flex-direction: row;
  font-family: "DINPro" !important;
  flex-wrap: wrap;
  margin-top: 0 !important;
}
.header-body-bar {
  background-color: white;
  box-shadow: 0 0.5em 1em -0.125em rgb(10 10 10 / 10%),
    0 0 0 1px rgb(10 10 10 / 2%);
  z-index: 6;
  width: 100%;
}
.py-15 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.header-body-text {
  font-weight: 600;
  font-family: "DINProMedium";
  font-size: 2rem;
}
.px-gen {
  padding-right: 2rem !important;
  padding-left: 2rem !important;
}
/*gen controla padding de los 3 modulos principales*/
.side-bar {
  flex: 22%;
  display: flex;
  flex-direction: column;
}
.py-gen {
  padding-top: 2rem;
  padding-bottom: 0;
}
.is-uppercase {
  text-transform: uppercase !important;
}
.is-capitalized {
  text-transform: capitalize !important;
}
</style>
